export default __webpack_public_path__ + "static/media/fire-protection.ca97e2be.png";